<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-col :span="24" class="form-line" style="padding-bottom: 0px;">
        <el-form size="small" :inline="true" :model="filters">
          <el-form-item label="景点名称">
            <el-input v-model="filters.name" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="类型">
            <el-select clearable v-model="filters.type" placeholder="请选择" style="width:100%">
              <el-option
                  v-for="item in types"
                  :key="item.dictKey"
                  :label="item.name"
                  :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="景点类型">
            <el-select clearable v-model="filters.noticeType" placeholder="请选择" style="width:100%">
              <el-option
                      v-for="item in noticeTypes"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <div style="float: right">
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-plus" @click="addNews">新增</el-button>
                <el-button type="primary" icon="el-icon-search" v-on:click="getPgaeList">查询</el-button>
                <el-button icon="el-icon-refresh-right" v-on:click="resetParameter">重置</el-button>

              </el-button-group>
            </el-form-item>
          </div>
        </el-form>
      </el-col>

      <!--列表-->
      <template>
        <el-table border :data="data" highlight-current-row v-loading="loading" style="width: 100%;">
          <el-table-column prop="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column prop="picture" label="封面图" min-width="60">
            <template slot-scope="scope" v-if="scope.row.imageUrl!=null && scope.row.imageUrl!=''">
              <img style="width: 50px;height: 50px;"
                   :src="scope.row.imageUrl"
                   class="avatar"
                   @click="previewAbout(scope.row.imageUrl)">
            </template>
          </el-table-column>
          <el-table-column prop="name" label="景点名称">
          </el-table-column>
          <el-table-column prop="openTime" label="开放时间">
          </el-table-column>
          <el-table-column prop="phone" label="服务热线">
          </el-table-column>
          <el-table-column prop="subscribe" label="是否开放预约" :formatter="formatSubscribe">
          </el-table-column>
          <el-table-column prop="people" label="满员人数">
          </el-table-column>
          <el-table-column prop="type" label="类型" :formatter="formatType">
          </el-table-column>
          <el-table-column prop="sortNum" label="排序">
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button class="btn-text-pd0" type="text" @click="handleEdit(1,scope.row.id)">详情</el-button>
              <el-button class="btn-text-pd0" type="text"
                         @click="handleEdit(2,scope.row.id)">编辑
              </el-button>
              <el-button class="btn-text-pd0" type="text" @click="delDx(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>

      <!--工具条-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="padding: 15px 5px">
      </el-pagination>

      <el-dialog :title="title" :visible.sync="formVisible" :close-on-click-modal="false" :before-close="cancelForm">

        <el-form :model="form" v-if="largeType!=='3'" :rules="formRules" label-width="150px" ref="form">
          <div style="padding-top: 10px">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="类型" prop="type">
                  <el-select :disabled="disabled" v-model="form.type" placeholder="请选择" style="width:100%">
                    <el-option
                        v-for="item in types"
                        :key="item.dictKey"
                        :label="item.name"
                        :value="item.dictKey">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="景点名称" prop="name">
                  <el-input :readonly="disabled" v-model="form.name" auto-complete="off" maxlength="100"
                            placeholder="请输入"></el-input>
                </el-form-item>
              </el-col>

            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="封面图">

                  <el-upload
                      accept=".jpg,.png"
                      :disabled="disabled"
                      class="upload-demo"
                      :action="uploadUrl"
                      :on-preview="handlePreview"
                      :on-remove="handleRemove"
                      :on-change="handleChange"
                      :file-list="titleFileList"
                      name="multipartFile"
                      :multiple="true"
                      :limit="1" :before-upload="beforeAvatarUpload">
                    <el-button size="small" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                  </el-upload>
                  <img style="width: 50px;height: 50px;" v-if="form.imageUrlYL!=undefined && form.imageUrlYL!=''"
                       :src="form.imageUrlYL"
                       class="avatar"
                       @click="previewAbout(form.imageUrlYL)">
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="内容" prop="content">
                  <!--                  <el-input  maxlength="500" :rows="10" type="textarea" :readonly="disabled" v-model="form.content"  auto-complete="off" placeholder="请输入内容"></el-input>-->

                  <quill-editor
                      class="ql-editor"
                      :disabled="disabled"
                      v-model="form.content"
                      ref="myQuillEditor"
                      :options="editorOption">
                  </quill-editor>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="排序" prop="sortNum">
                  <el-input-number v-model="form.sortNum" :min="1" :max="99"></el-input-number>

                </el-form-item>
              </el-col>
            </el-row>

          </div>
        </el-form>
        <el-tabs type="border-card" v-if="largeType==='3'">
          <el-tab-pane label="详情">
            <el-form :model="form" :rules="formRules" label-width="150px" ref="form">
              <div style="padding-top: 10px">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="类型" prop="type">
                      <el-select :disabled="disabled" v-model="form.type" placeholder="请选择" style="width:100%">
                        <el-option
                            v-for="item in types"
                            :key="item.dictKey"
                            :label="item.name"
                            :value="item.dictKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="景点类型">
                      <el-select clearable v-model="form.noticeType" placeholder="请选择" style="width:100%">
                        <el-option
                                v-for="item in noticeTypes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="游玩类型">
                      <el-select clearable v-model="form.play" placeholder="请选择" style="width:100%">
                        <el-option
                                v-for="item in plays"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="景点名称" prop="name">
                      <el-input :readonly="disabled" v-model="form.name" auto-complete="off" maxlength="100"
                                placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                      <div class="map-box">
                          <el-amap-search-box  class="search-box"
                                               :default="defaultValue" :search-option="searchOption"
                                               :on-search-result="onSearchResult">
                          </el-amap-search-box>
                          <el-amap ref="map" vid="amapDemo"  style="width:100%;height:400px" :events="events" :center="center" :zoom="zoom" >
                              <el-amap-marker :position="center" key="100"></el-amap-marker>
                          </el-amap>
                      </div>
                    <el-form-item label="地理位置" prop="address">
                      <el-input :readonly="disabled" v-model="form.address" auto-complete="off" maxlength="100"
                                placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="三维链接" prop="openTime">
                      <el-input :readonly="disabled" v-model="form.url" auto-complete="off" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="开放时间" prop="openTime">
                      <el-input :readonly="disabled" v-model="form.openTime" auto-complete="off" maxlength="100"
                                placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="服务热线" prop="phone">
                      <el-input :readonly="disabled" v-model="form.phone" auto-complete="off" maxlength="100"
                                placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="满员人数" prop="people">
                      <el-input-number :readonly="disabled" v-model="form.people" auto-complete="off" maxlength="100"
                                placeholder="请输入"></el-input-number>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="是否开放预约" prop="type">
                      <el-select :disabled="disabled" v-model="form.subscribe" placeholder="请选择" style="width:100%">
                        <el-option
                                v-for="item in subscribes"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="选择原因">
                      <el-link  type="primary" @click="setRepair('设施改造')">设施改造</el-link>&nbsp;
                      <el-link  type="success" @click="setRepair('闭馆维护')">闭馆维护</el-link>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="维修原因" prop="repair">
                      <el-input :readonly="disabled" v-model="form.repair" auto-complete="off" maxlength="100"
                                placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>

                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="维修时间" >
                      <el-date-picker
                              v-model="value1"
                              range-separator="至"
                              start-placeholder="开始日期"
                              type="daterange"
                              value-format="yyyy-MM-dd"
                              end-placeholder="结束日期">
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="封面图">

                      <el-upload
                          accept=".jpg,.png"
                          :disabled="disabled"
                          class="upload-demo"
                          :action="uploadUrl"
                          :on-preview="handlePreview"
                          :on-remove="handleRemove"
                          :on-change="handleChange"
                          :file-list="titleFileList"
                          name="multipartFile"
                          :multiple="true"
                          :limit="1" :before-upload="beforeAvatarUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                      <img style="width: 50px;height: 50px;" v-if="form.imageUrlYL!=undefined && form.imageUrlYL!=''"
                           :src="form.imageUrlYL"
                           class="avatar"
                           @click="previewAbout(form.imageUrlYL)">
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="内容" prop="content">
                      <!--                  <el-input  maxlength="500" :rows="10" type="textarea" :readonly="disabled" v-model="form.content"  auto-complete="off" placeholder="请输入内容"></el-input>-->

                      <quill-editor
                          class="ql-editor"
                          :disabled="disabled"
                          v-model="form.content"
                          ref="myQuillEditor"
                          :options="editorOption">
                      </quill-editor>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="排序" prop="sortNum">
                      <el-input-number v-model="form.sortNum" :min="1" :max="99"></el-input-number>

                    </el-form-item>
                  </el-col>
                </el-row>

              </div>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="留言">
            <el-table border size="medium" :data="messageList" highlight-current-row>
              <el-table-column type="index" min-width="60">
              </el-table-column>
              <el-table-column prop="content" label="内容" min-width="240">
              </el-table-column>

              <el-table-column prop="userName" label="创建人" min-width="120">
              </el-table-column>
              <el-table-column prop="createDate" label="创建时间" min-width="120">
              </el-table-column>
              <el-table-column label="操作" min-width="120">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handleMsg(scope.row.id,false)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>

          </el-tab-pane>
        </el-tabs>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click.native="cancelForm">取消</el-button>
          <el-button v-if="type == 2" size="medium" type="primary" @click.native="formSubmit" :loading="formLoading">
            提交
          </el-button>
        </div>
      </el-dialog>
      <el-dialog title="回复留言" :visible.sync="replyVisible">
        <el-form :model="reply">
          <el-form-item label="内容">
            <el-input type="textarea" v-model="reply.content" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="replyVisible = false">取 消</el-button>
          <el-button type="primary" @click="subminReply">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="查看图片" :visible.sync="largePicVisible" :close-on-click-modal="false">
        <img :src="largePicUrl" style="width: 100%">
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="largePicVisible = false">关闭</el-button>
        </div>
      </el-dialog>
      <el-dialog title="留言记录" :visible.sync="msgVisible" :close-on-click-modal="false">
        <el-tree :data="messageReply" default-expand-all :expand-on-click-node="false" node-key="id"
                 :props="{label: 'content', children: 'sonList'}"
                 ref="tree"
        >
          <template #default="{ node, data }">
                  <span class="custom-tree-node">

                    <span >{{ data.createDate }}·{{ data.userName }}</span>
                      <span><span style="padding-right: 10px">：{{ node.label }}</span></span>
                     <span>
                      <span style="padding-right: 10px">
                        <el-link type="primary" :underline="false" @click="handleReply(data)">回复</el-link>
                      </span>
                    </span>
                  </span>
          </template>
        </el-tree>
        <div slot="footer" class="dialog-footer">
          <el-button @click.native="msgVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>
<script>
/* eslint-disable */
import { base, doPost, initHeaders, download, getDownLoadUrl } from '../../api/api'
import { quillRedefine } from 'vue-quill-editor-upload'

import { Video } from '../../api/video'

const quill = require('quill')
quill.register({ 'formats/video': Video }, true)
export default {
  data () {

      let _this = this;
    return {
        zoom: 16,
        center: [119.647265, 29.079195],
        searchOption: {
            // 限制搜索城市的范围
            citylimit: '金华市',
        },
        defaultValue: "",
        events: {
            click(e) {
                _this.center = [e.lnglat.lng, e.lnglat.lat];
                _this.form.longitude = e.lnglat.lng;
                _this.form.latitude = e.lnglat.lat;
                _this.getAddress(_this.center);
                _this.defaultValue = "";
            },
        },
      value1: '',
      messageList: [], msgVisible: false, props: { children: 'sonList', label: 'content' },
      filters: { name: '', type: '', status: '' ,noticeType: ''},
      type: '',     //区分详情
      loading: false,
      data: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      editorOption: {
        theme: 'snow'
      },
      form: {
        id: '',
        name: '',                //政策名称
        address: '',                //政策名称
        openTime: '',                //政策名称
        phone: '',                //政策名称
        people: 0,                //政策名称
        content: '',             //政策内容
        type: '',                //政策类型
        repair: '',                //政策类型
        subscribe: '1',                //政策类型
        sDate: null,                //政策类型
        eDate: null,                //政策类型
        status: '1',              //政策状态
        uploadFileStr: '', imageUrl: '', imageUrlYL: '', sortNum: 99
      },
      plusIconVisible: false, messageReply: [],
      formVisible: false,
      title: '',
      formRules: {
        name: [
          { required: true, message: '请输入!', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入!', trigger: 'blur' }
        ],
        openTime: [
          { required: true, message: '请输入!', trigger: 'blur' }
        ],
        phone: [
          { required: false, message: '请输入!', trigger: 'blur' }
        ],
        people: [
          { required: false, message: '请输入!', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入!', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '请选择!', trigger: 'blur' }
        ],
        subscribe: [
          { required: true, message: '请选择!', trigger: 'blur' }
        ],
        sortNum: [
          { required: true, message: '请输入!', trigger: 'blur' }
        ],
        // status: [
        //   {required: true, message: '请输入政策状态!', trigger: 'blur'}
        // ],
      },
      disabled: false,
      formLoading: false,
      user: {},
      types: [],
      subscribes: [
        { label: '是', value: '1' },
        { label: '否', value: '0' }
      ],
      noticeTypes: [
        { label: '住宿', value: '1' },
        { label: '美食', value: '2' },
        { label: '游玩', value: '3' },
      ],
      plays: [
        { label: '休闲好去处', value: '0' },
        { label: '闲暇阅时光', value: '1' },
        { label: '村民乐生活', value: '2' },
      ],
      statuss: [
        { label: '未发布', value: '1' },
        { label: '已发布', value: '2' }
      ],
      searchType2: 1,
      //上传附件
      uploadUrl: base + '/sysUploadFile/uploadFile',
      headers: '', largeType: 1,
      titleFileList: [],
      uploadFiles: [], largePicVisible: false,
      largePicUrl: '', msgtotal: 0, filtersMsg: {}, replyVisible: false, reply: { content: '', },
    }
  },
  methods: {
      onSearchResult(pois) {
          //搜索
          let latSum = 0;
          let lngSum = 0;
          let that = this;
          if (pois && pois.length > 0) {
              //如果长度为1则无需转化
              let poi = pois[0];
              let lng = poi["lng"];
              let lat = poi["lat"];
              that.center = [lng, lat];
              that.zoom = 18;
              that.content = poi.name;
              that.searchResult.address = poi.address;
              that.searchResult.latitude = poi.lat;
              that.searchResult.longitude = poi.lng;
              that.form.longitude = lng;
              that.form.latitude = lat;
              that.getAddress(that.center);
          } else {
              that.searchResult = [];
          }
      },
      // 获取详细地址
      getAddress(center) {
          let _this = this;
          let geocoder = new AMap.Geocoder({});
          geocoder.getAddress(center, function (status, result) {
              if (status === "complete" && result.info === "OK") {
                  var address = result.regeocode.formattedAddress
                  _this.form.address = address;
              }
          });
      },
      setRepair(e){
          this.form.repair+=e
      },
    subminReply () {
      if (this.reply.content === '') {
        this.$message({
          message: '请输入回复内容',
          type: 'error'
        })
        return
      }
      let para = this.reply
      para.type = 2
      para.createBy = this.user.id
      console.log(para)
      this.$confirm(' 是否提交', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        doPost('/sysMessageReply/saveOrUpdate', para).then((res) => {
          this.$message({
            message: '已回复',
            type: 'success'
          })
          this.replyVisible = false
          this.msgVisible = false
        })
      })
    },
    handleReply (data) {
      console.log(data)
      this.reply.content === ''
      this.reply.parentId = data.id
      this.reply.relationId = data.relationId
      this.replyVisible = true
    },
    fmt_isReply (obj) {
      console.log(obj)
      if (obj.isReply === '1') return '是'
      if (obj.isReply === '2') return '否'
    },
    getMessageList () {
      this.loading = true
      let para = this.filtersMsg
      para.type = 1
      doPost('/sysMessageReply/getPageList', para).then((res) => {
        console.log(res.result)
        this.msgtotal = res.result.total
        this.messageList = res.result.list
        this.loading = false
      })
    },
    initQuill () {
      this.editorOption = quillRedefine(
          {
            // 图片上传的设置
            uploadConfig: {
              action: this.uploadUrl,  // 必填参数 图片上传地址
              methods: 'POST',  // 可选参数 图片上传方式  默认为post
//            header: { 'Content-Type': 'application/x-www-form-urlencoded' },
//            headers:this.initHeaders(),
//            token:JSON.parse(sessionStorage.getItem('user')).reqToken,
              // 必选参数  res是一个函数，函数接收的response为上传成功时服务器返回的数据
              // 你必须把返回的数据中所包含的图片地址 return 回去
              res: (respnse) => {
                console.log(respnse)
                return getDownLoadUrl(respnse.result)
              },
              name: 'multipartFile'  // 图片上传参数名
            }
          }
      )
    },
    // 限制上传格式
    beforeAvatarUpload (file) {
      // if (this.titleFileList.length > 0) {
      //   this.$message.error('封面只允许上传一张图片')
      //   return false
      // }
      const isJPG = file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 10
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片只能是JPG格式或PNG格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return (isJPG || isPNG) && isLt2M
    },
    // 上传
    handleChange (file, titleFileList) {
      console.log(titleFileList)
      if (titleFileList.length > 0) {
        var a = titleFileList.length - 1
        if (titleFileList[a].status === 'success') {
          this.titleFileList = titleFileList
          this.form.imageUrl = titleFileList[a].response.result
          this.form.imageUrlYL = getDownLoadUrl(this.form.imageUrl)
          console.log(this.form)
        }
      }
    },
    //上传
    handlePreview (file) {
    },
    //删除文件
    handleRemove (file, fileList) {
      const index = this.titleFileList.findIndex(e => e.uid === file.uid)
      this.titleFileList.splice(index, 1)
    },
    //下载
    handleDownload (item) {
      const url = item.url + '&attname=' + item.name
      const fileName = item.name
      if (!url) {
        return
      }
      let link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      // let para = Object.assign({}, {fileName: item.name, fileUrl: item.url +"&attname="+item.name})
      // download('/sysUploadFile/downloadFile', para, item.name).then((res) => {
      //   console.log(res)
      // })
    },
    //筛选展开
    changeSearchType () {
      if (this.searchType2 === 1) {
        this.searchType2 = 2
      } else {
        this.searchType2 = 1
      }
    },

    resetParameter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
      this.getPgaeList()
    },

    // 分页
    handleSizeChange (val) {
      this.pageSize = val
      this.getPgaeList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getPgaeList()
    },

    // 获取列表（查询条件，欠缺调整）
    getPgaeList: function () {
      this.loading = true
      let para = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        name: this.filters.name,
        type: this.filters.type,
      }
      para.largeType = this.largeType
      console.log(para)
      doPost('/sysNotice/getPageList', para).then(res => {
        this.data = res.result.list
        if (this.data !== null && this.data.length > 0) {
          for (var a in this.data) {
            this.data[a].index = (res.result.pageNum - 1) * res.result.pageSize + parseInt(a) + 1
            this.data[a].imageUrl = getDownLoadUrl(this.data[a].imageUrl)
          }
        }
        console.log(this.data)
        this.total = res.result.total
      })
      this.loading = false
    },
    //新增
    addNews () {
      this.titleFileList = []
      this.uploadFiles = []
      this.title = '新增'
      this.formVisible = true
      this.plusIconVisible = false
      this.disabled = false
      this.type = 2
      // this.form = {
      //   id: '',
      //   name: '',                //政策名称
      //   content: '',             //政策内容
      //   type: '',                //政策类型
      //   status: '1',              //政策状态
      //   uploadFileStr: '',
      // }
      Object.assign(this.$data.form, this.$options.data().form)
    },
    //提交
    formSubmit: function () {
      const _fileList = this.titleFileList
      for (var i in _fileList) {
        this.uploadFiles.push({
          fileUrl: _fileList[i].hasOwnProperty('response') === true ? _fileList[i].response.result : _fileList[i].name,
          fileName: _fileList[i].name,
          modelType: 'policy_id'
        })
      }
      this.form.uploadFileStr = this.uploadFiles.length === 0 ? '' : JSON.stringify(this.uploadFiles)
      console.log(this.form.uploadFileStr)
      this.form.largeType = this.largeType
      this.form.sDate = this.value1[0]
      this.form.eDate = this.value1[1]
      console.log(this.form)
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗', '提示', {
            confirmButtonText: '继续提交',
            cancelButtonText: '取消'
          }).then(() => {
            this.formLoading = true
            let para = Object.assign({}, this.form)
            doPost('/sysNotice/saveOrUpdate', para).then((res) => {
              this.formLoading = false
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.cancelForm()
              this.getPgaeList()
            })
          })
        }
      })
    },
    //删除
    delDx: function (id) {
      let para = {
        id: id,
        delFlag: 2
      }
      this.$confirm('确认删除吗', '提示', {
        confirmButtonText: '继续删除',
        cancelButtonText: '取消'
      }).then(() => {
        this.formLoading = true
        doPost('/sysNotice/delete', para).then((res) => {
          this.formLoading = false
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.formVisible = false
          this.getPgaeList()
        })
      })
    },
    //发布
    updateStatus: function (status, id) {
      let para = {
        id: id,
        status: status
      }
      this.$confirm('确定操作吗？', '提示', {
        confirmButtonText: '继续',
        cancelButtonText: '取消'
      }).then(() => {
        this.formLoading = true
        doPost('/sysNotice/updateStatus', para).then((res) => {
          this.formLoading = false
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getPgaeList()
        })
      })
    },
    handleMsg (id) {
      this.reply.pid = id
      doPost('/sysMessageReply/getMessageReply', { id: id }).then((res) => {
        console.log(res.result)
        this.messageReply = res.result
        this.msgVisible = true
      })
    },
    //编辑
    handleEdit: function (type, id) {
      this.type = type
      if (type === 1) {
        this.title = '详情'
        this.plusIconVisible = false
        this.disabled = true
      } else if (type === 2) {
        this.title = '编辑'
        this.plusIconVisible = false
        this.disabled = false
      } else if (type === 3) {
        this.title = '发布'
        this.plusIconVisible = false
        this.disabled = true
      }
      this.formVisible = true
      let para = {
        id: id
      }
      doPost('/sysNotice/getById', para).then(res => {
        this.form = res.result
        if(this.form.sDate==null || this.form.sDate ===''){
          this.value1 =[]
        }else{
          this.value1 =[this.form.sDate,this.form.eDate]
        }

        console.log(this.value1)
        this.filtersMsg.relationId = this.form.id
        this.getMessageList()
        // const fileList = this.form.uploadFileList;
        const _FileList = []
        this.form.imageUrlYL = getDownLoadUrl(this.form.imageUrl)
        // _FileList.push({url:getDownLoadUrl( this.form.imageUrl), })
        console.log(_FileList)
        this.titleFileList = _FileList
        delete this.form.uploadFileList
      })
    },
    //点击取消(处理规则校验)
    cancelForm () {
      this.formVisible = false
      this.$refs['form'].resetFields()
      this.titleFileList = []
      this.uploadFiles = []
    },
    previewAbout (url) {
      this.largePicUrl = url
      this.largePicVisible = true
    },
    formatType: function (row, column) {
      for (var i in this.types) {
        if (row.type == this.types[i].dictKey) {
          return this.types[i].name
        }
      }
    },
    formatSubscribe: function (row, column) {
      for (var i in this.subscribes) {
        if (row.subscribe == this.subscribes[i].value) {
          return this.subscribes[i].label
        }
      }
    },
    formatstatus: function (row, column) {
      for (var i in this.statuss) {
        if (row.status === this.statuss[i].value) {
          return this.statuss[i].label
        }
      }
    },

    getTypesData () {
      var str = []
      var para = {}
      para.dictType = 'sysNoticeType'
      para.dictKey = this.largeType
      doPost('/sysNotice/getTypeList', para).then(res => {
        this.types = res.result
        console.log(res)
        this.getPgaeList()
      })
    },
    // 获取文件后缀名
    getFileSuffix: function (fileName) {
      var startIndex = fileName.lastIndexOf('.') + 1
      var endIndex = fileName.length
      return fileName.substring(startIndex, endIndex)
    },
    initHeaders: function () {
      var headers = {}
      var user = JSON.parse(sessionStorage.getItem('user'))
      if (user) {
        console.log('用户令牌=' + user.reqToken)
        headers.reqToken = user.reqToken
      }
      return headers
    },
    judgePath (path) {

      console.log(path)
      this.headers = this.initHeaders()
      if (path === '/sysNotice1') {
        this.largeType = '1'
        this.getPgaeList()
      } else if (path === '/sysNotice2') {
        this.largeType = '2'
        this.getPgaeList()
      } else if (path === '/sysNotice3') {
        this.largeType = '3'
        this.getPgaeList()
      } else if (path === '/sysNotice4') {
        this.largeType = '4'
        this.getPgaeList()
      }
      this.getTypesData()
    },
  },
  mounted () {

    this.initQuill()
    this.judgePath(this.$route.fullPath)
  }
  ,
  watch: {
    // 监听矛盾用户管理页面切换
    $route (to, from) {
      this.judgePath(to.path)
    }
  }
}

</script>

<style>
.pl-box {
  background-color: #F7F5F6;
  border-radius: 16rpx;
  margin: 0 30rpx 30rpx 30rpx;
  padding: 30rpx;
}

.img-head {
  width: 60rpx;
  height: 60rpx;
  border-radius: 50%;
}

.btn-box {
  position: fixed;
  bottom: 38rpx;
  left: 0;
  width: 100%;
}

.btn-pinglun {
  background-color: #F6F6F6;
  padding: 10rpx 12rpx;
  border-radius: 8rpx;
  font-size: 24rpx;
  color: #FF601A;
  display: flex;
  align-items: center;
}

.btn-pinglun image {
  width: 30rpx;
  height: 30rpx;
  margin-right: 8rpx;
}

.textarea {
  background-color: #fff;
  border-radius: 16rpx;
  width: 100%;
  padding: 20rpx;
  font-size: 28rpx;
}
</style>

